<script setup>
import Footer from "@/components/Footer.vue";
import Card from "@/components/ui/card/Card.vue";
import CardContent from "@/components/ui/card/CardContent.vue";
import CardHeader from "@/components/ui/card/CardHeader.vue";
import { setDarkMode } from "@/darkmode.js";
import HeaderView from "@/views/HeaderView.vue";
import SettingsView from "@/views/SettingsView.vue";
import { onMounted, ref } from "vue";
const data = ref(null);

const fetchData = async () => {
  data.value = "hello";
};

onMounted(() => {
  fetchData();
});

function handleDarkModeToggle(value) {
  if (value.state === "checked") {
    setDarkMode(true);
  }
  if (value.state === "unchecked") {
    setDarkMode(false);
  }
}
</script>

<template>
  <Card class="h-dvh rounded-none border-none bg-background">
    <CardHeader> <HeaderView name="Settings"></HeaderView> </CardHeader>

    <CardContent>
      <SettingsView @onDarkModeChange="handleDarkModeToggle" />
    </CardContent>
  </Card>

  <Footer></Footer>
</template>
